import React, { useEffect, useState } from "react";
import styles from "./FooterBar.module.css";
import { Link } from "react-router-dom";

// Utility to get cookies
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return decodeURIComponent(parts.pop().split(";").shift());
  return null;
};
// Utility to set cookies
const setCookie = (name, value, days = 365) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/`;
};

function FooterBar() {
  const currentYear = new Date().getFullYear();
  const [showModal, setShowModal] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true,
    functional: true,
    performance: false,
    targeting: false,
  });

  useEffect(() => {
    const cookieValue = getCookie("cookieConsent");
    if (cookieValue) {
      try {
        const parsed = JSON.parse(cookieValue);
        setPreferences((prev) => ({
          ...prev,
          ...parsed, // Merge saved preferences
        }));
      } catch (err) {
        console.error("Failed to parse cookieConsent cookie:", err);
      }
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // You can use 'auto' for instant scrolling
    });
  };
  const handleSavePreferences = () => {
    setCookie("cookieConsent", JSON.stringify(preferences));
    setShowModal(false);
  };
  const togglePref = (key) => {
    if (key === "essential" || key === "functional") return; // Always enabled
    setPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className={styles.footerBarMainContainer}>
      <div className={`${styles.footerBar} container px-3`}>
        <div className={styles.policyContainer}>
          <Link to="/">
            <p className={styles.minfert}>
              Minfert © {currentYear}. All Rights Reserved{" "}
            </p>
          </Link>
          <div className="d-flex flex-wrap">
            <Link to="/privacy-policy" className={styles.minfert}>
              <p> | Privacy Policy</p>
            </Link>
            <Link to="/cookie-policy" className={styles.minfert}>
              <p> | Cookie Policy</p>
            </Link>
            <Link onClick={() => setShowModal(true)} className={styles.minfert}>
              <p> | Cookies Preferences</p>
            </Link>
            <Link to="/terms&conditions" className={styles.minfert}>
              <p> | Terms & Conditions</p>
            </Link>
            <Link to="/cancellation-and-refund" className={styles.minfert}>
              <p> | Cancellation & Refund</p>
            </Link>
          </div>
        </div>
        <Link to="https://webanixsolutions.com/" target="_blank" className={styles.linkItem}>
        <p className={styles.navItems} onClick={scrollToTop}>
        Designed by WEBaniX Pvt Ltd
          </p>
        </Link>

        {showModal && (
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: "999",
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: "2rem",
                borderRadius: "8px",
                width: "90%",
                maxWidth: "500px",
                maxHeight: "90%",
                overflowY: "scroll",
                position: "relative",
              }}
            >
              <h2>We Value Your Privacy</h2>
              <p>
                We use cookies to enhance your experience. Some are essential,
                while others help us improve the site and serve personalized
                ads. Choose your preferences below:
              </p>

              <div style={{ marginTop: "1rem" }}>
                {[
                  { key: "essential", label: "Essential Cookies" },
                  { key: "functional", label: "Functional Cookies" },
                  { key: "performance", label: "Performance Cookies" },
                  { key: "targeting", label: "Targeting Cookies" },
                ].map(({ key, label }) => (
                  <div key={key} style={{ marginBottom: "0.5rem" }}>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={preferences[key]}
                        onChange={() => togglePref(key)}
                        style={{ marginRight: "8px" }}
                      />
                      {label}
                    </label>
                  </div>
                ))}
              </div>

              <div
                style={{
                  marginTop: "1.5rem",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => setShowModal(false)}
                  style={{
                    background: "transparent",
                    border: "1px solid gray",
                    padding: "8px 16px",
                    cursor: "pointer",
                    flex: "1 1 150px",
                    minWidth: "120px",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSavePreferences}
                  style={{
                    background: "var(--green)",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "bold",
                    flex: "1 1 150px",
                    minWidth: "120px",
                  }}
                >
                  Save Preferences
                </button>
              </div>
            </div>
          </div>
        )}

        {/* <ul className={styles.menus}>
        
      </ul> */}
      </div>
    </div>
  );
}

export default React.memo(FooterBar); // Memoize the FooterBar
